module.exports = __webpack_public_path__ + "static/12-7355df8d1dafa3364d18f9a3d6239de8.jpg";